import React, {useState} from "react";
import {Col, Descriptions, Divider, Form, Row, Tag} from "antd";
import {
    courierBonusCampaignStatuses,
    courierBonusCampaignTypes,
    daysList,
    guaranteeCalculationFactors
} from "../../../../../constants/constants";
import MinimumPackagesInput from "../minimumPackagesInput/MinimumPackagesInput";
import moment from "moment";
export default function CampaignDetailViewer({campaign, refetch = () => {}}) {
    const campaignType = campaign?.type;

    return (
        <Row>
            <Col span={24}>
                <Descriptions
                    bordered
                    column={4}
                    layout="horizontal"
                    size="small"
                    style={{width: "100%"}}
                >
                    <Descriptions.Item
                        span={2}
                        label="Kampanya Adı"
                        labelStyle={{borderBottom: "1px solid #f0f0f0"}}
                        contentStyle={{borderBottom: "1px solid #f0f0f0"}}
                    >
                        {campaign?.name}
                    </Descriptions.Item>
                    <Descriptions.Item
                        span={2}
                        label="Kampanya Tipi"
                        labelStyle={{borderBottom: "1px solid #f0f0f0"}}
                        contentStyle={{borderBottom: "1px solid #f0f0f0"}}
                    >
                        {
                            Object.values(courierBonusCampaignTypes).find(
                                type => type.value === campaign?.type
                            )?.label
                        }
                    </Descriptions.Item>
                    <Descriptions.Item
                        span={2}
                        label="Kampanya Başlangıç Tarihi"
                        labelStyle={{borderBottom: "1px solid #f0f0f0"}}
                        contentStyle={{borderBottom: "1px solid #f0f0f0"}}
                    >
                        {campaign?.startDate
                            ? moment(campaign?.startDate).format("DD.MM.YYYY HH:mm")
                            : ""}
                    </Descriptions.Item>
                    <Descriptions.Item
                        span={2}
                        label="Kampanya Bitiş Tarihi"
                        labelStyle={{borderBottom: "1px solid #f0f0f0"}}
                        contentStyle={{borderBottom: "1px solid #f0f0f0"}}
                    >
                        {campaign?.endDate
                            ? moment(campaign?.endDate).format("DD.MM.YYYY HH:mm")
                            : ""}
                    </Descriptions.Item>
                    <Descriptions.Item
                        span={2}
                        label="Kampanya Başlangıç Saati"
                        labelStyle={{borderBottom: "1px solid #f0f0f0"}}
                        contentStyle={{borderBottom: "1px solid #f0f0f0"}}
                    >
                        {campaign?.startHour
                            ? moment(campaign?.startHour, "HH:mm").format("HH:mm")
                            : ""}
                    </Descriptions.Item>
                    <Descriptions.Item
                        span={2}
                        label="Kampanya Bitiş Saati"
                        labelStyle={{borderBottom: "1px solid #f0f0f0"}}
                        contentStyle={{borderBottom: "1px solid #f0f0f0"}}
                    >
                        {campaign?.endHour
                            ? moment(campaign?.endHour, "HH:mm").format("HH:mm")
                            : ""}
                    </Descriptions.Item>
                    <Descriptions.Item
                        span={2}
                        label="Kampanya Günleri"
                        labelStyle={{borderBottom: "1px solid #f0f0f0"}}
                        contentStyle={{borderBottom: "1px solid #f0f0f0"}}
                    >
                        <div style={{display: "flex", flexWrap: "wrap", maxWidth: "300px", gap: 4}}>
                            {daysList
                                .filter(day => campaign?.days?.includes(day.value))
                                .map(day => (
                                    <Tag key={day.value}>{day.name}</Tag>
                                ))}
                        </div>
                    </Descriptions.Item>
                    <Descriptions.Item
                        span={2}
                        label="Kampanya Durumu"
                        labelStyle={{borderBottom: "1px solid #f0f0f0"}}
                        contentStyle={{borderBottom: "1px solid #f0f0f0"}}
                    >
                        {
                            Object.values(courierBonusCampaignStatuses).find(
                                status => status.value === campaign?.status
                            )?.label
                        }
                    </Descriptions.Item>
                </Descriptions>
                <Divider />

                {campaignType === courierBonusCampaignTypes.PACKAGE_BONUS_FEE.value && (
                    <Col sm={12} xs={24} style={{margin: "8px 8px 8px -25px"}}>
                        <Form.Item>
                            <MinimumPackagesInput
                                value={
                                    campaign?.conditions[
                                        courierBonusCampaignTypes.PACKAGE_BONUS_FEE.value
                                    ]?.courierAmountsByPackageCount?.map(item => ({
                                        minPackageCount: item.minimumPackageCount,
                                        paymentAmount: item.courierAmount
                                    })) || []
                                }
                                disabled={true}
                            />
                        </Form.Item>
                    </Col>
                )}

                {campaignType === courierBonusCampaignTypes.HOURLY_FEE.value && (
                    <Row>
                        <Col span={12}>
                            <Descriptions
                                //  title="Kampanya Detayı"
                                bordered
                                column={4}
                                size="small"
                                layout="horizontal"
                            >
                                <Descriptions.Item
                                    span={4}
                                    label="Kurye Tutarı"
                                    labelStyle={{borderBottom: "1px solid #f0f0f0"}}
                                    contentStyle={{borderBottom: "1px solid #f0f0f0"}}
                                >
                                    {
                                        campaign?.conditions[
                                            courierBonusCampaignTypes.HOURLY_FEE.value
                                        ]?.courierAmount
                                    }
                                </Descriptions.Item>
                                <Descriptions.Item
                                    span={4}
                                    label="Firma Tutarı"
                                    labelStyle={{borderBottom: "1px solid #f0f0f0"}}
                                    contentStyle={{borderBottom: "1px solid #f0f0f0"}}
                                >
                                    {
                                        campaign?.conditions[
                                            courierBonusCampaignTypes.HOURLY_FEE.value
                                        ]?.companyAmount
                                    }
                                </Descriptions.Item>
                            </Descriptions>
                        </Col>
                    </Row>
                )}

                {campaignType === courierBonusCampaignTypes.HOURLY_GUARANTEE_FEE.value && (
                    <Row>
                        <Col span={12}>
                            <Descriptions
                                //  title="Kampanya Detayı"
                                bordered
                                column={4}
                                size="small"
                                layout="horizontal"
                            >
                                <Descriptions.Item
                                    span={4}
                                    label="Kurye Tutarı"
                                    labelStyle={{borderBottom: "1px solid #f0f0f0"}}
                                    contentStyle={{borderBottom: "1px solid #f0f0f0"}}
                                >
                                    {
                                        campaign?.conditions[
                                            courierBonusCampaignTypes.HOURLY_GUARANTEE_FEE.value
                                        ]?.guaranteeAmount
                                    }
                                </Descriptions.Item>
                                <Descriptions.Item
                                    span={4}
                                    label="Garanti Faktörleri"
                                    labelStyle={{borderBottom: "1px solid #f0f0f0"}}
                                    contentStyle={{borderBottom: "1px solid #f0f0f0"}}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            maxWidth: "300px",
                                            gap: 4
                                        }}
                                    >
                                        {Object.values(guaranteeCalculationFactors)
                                            .filter(factor =>
                                                campaign?.conditions[
                                                    courierBonusCampaignTypes.HOURLY_GUARANTEE_FEE
                                                        .value
                                                ]?.calculationFactors?.includes(factor.value)
                                            )
                                            .map(factor => (
                                                <Tag key={factor.value}>{factor.label}</Tag>
                                            ))}
                                    </div>
                                </Descriptions.Item>
                            </Descriptions>
                        </Col>
                    </Row>
                )}
            </Col>
        </Row>
    );
}
